import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryAvailableTonesOfVoiceArgs, BackendToneOfVoice } from 'src/types/backend';

const QUERY = gql`
  query AvailableTonesOfVoice(
    $projectType: String!
    $assetType: String!
    $generationType: String!
    $contentType: String
  ) {
    availableTonesOfVoice(
      projectType: $projectType
      assetType: $assetType
      generationType: $generationType
      contentType: $contentType
    ) {
      id
      title
      hint
      keywordsEnabled
    }
  }
`;

type Variables = BackendQueryAvailableTonesOfVoiceArgs;
type Result = Pick<BackendToneOfVoice, 'id' | 'title' | 'hint' | 'keywordsEnabled'>[];

export const queryAvailableTonesOfVoice = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
